import React from "react";
import { useParams } from "react-router-dom";
import { CalendarClock } from "lucide-react";
import { PageHeader } from "../../components/common";
import { FollowUpVisitsReport } from "../../components/FollowUpVisitsReport";
import { ReadOnlyNotice } from "../../components/FeatureGate";
import { useRoleModules } from "../../lib/roleModules";

/**
 * Phase 196 — Supervisor › Follow-up Visits: the supervisor's own follow-ups plus those of the collectors in their
 * territory. The API scopes the rows; with write access the supervisor may also mark a team follow-up Done or
 * reschedule it (the collector is notified).
 */
export default function SupervisorFollowUpVisits() {
  const { code } = useParams();
  const access = useRoleModules(code);
  const readOnly = access.loaded && !access.canWrite("follow_up_visits");
  return (
    <div data-testid="supervisor-follow-up-visits-page">
      <PageHeader title="Follow-up Visits"
        subtitle="Return visits scheduled by you and by the collectors under you. Overdue entries stay here until they are marked Done with a reason; 3 or more follow-ups without a payment show the Repeated Follow-up badge so you can step in.">
        <span className="inline-flex items-center gap-1.5 text-xs text-muted-foreground"><CalendarClock className="h-3.5 w-3.5" /> My team</span>
      </PageHeader>
      {readOnly && <ReadOnlyNotice what="follow-up visits" testId="supervisor-fu-readonly-notice" className="mb-4" />}
      <FollowUpVisitsReport code={code} role="supervisor" testId="supervisor-fu" canAct={!readOnly}
        propertyPath={(r) => `/${code}/supervisor/properties?focus=${r.property_id}`} />
    </div>
  );
}
